import { QuestionIcon } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import { CountBadge } from 'app/components/inbox/CountBadge'
import { Button } from 'app/components/ui/button'
import { intercomEnabled } from 'app/intercom'

/**
 * Replaces Intercom's floating launcher, which is booted with
 * `hide_default_launcher` because it sat over the contact drawer's Send
 * button. Sits under Notifications in the sidebar and mirrors a top-level
 * nav row (see the icon params in lib/sidebarItems); hidden on origins where
 * the widget never loads so it is never a dead control.
 */
export function IntercomHelpButton(): React.ReactElement | null {
  const enabled = intercomEnabled()
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    if (!enabled) return
    // Queued until the widget script loads, so this is safe before boot.
    window.Intercom?.(`onUnreadCountChange`, (count: number) => setUnreadCount(count))
  }, [enabled])

  if (!enabled) return null

  return (
    <Button
      type="button"
      variant="ghost"
      size="row"
      aria-label={unreadCount > 0 ? `Help (${unreadCount} unread)` : `Help`}
      onClick={() => window.Intercom?.(`show`)}
      className="mb-2 flex h-9"
    >
      <span className="flex h-9 w-9 items-center justify-center">
        {/* size-5 keeps the 20px the other nav icons use; Button shrinks unsized svgs to 16px. */}
        <QuestionIcon size={20} weight="bold" className="size-5 text-default" aria-hidden="true" />
      </span>
      <span className="flex h-9 min-w-0 grow items-center truncate text-left text-heading-xs text-strong">Help</span>
      <CountBadge value={unreadCount} className="ml-auto" />
    </Button>
  )
}
